<template>
  <div class="choose-course">
    <Modal v-model="show" title="圈定报名范围" :footer-hide="true" width="1100">
      <!-- <Tabs v-model="tab" @on-click="onTabClick">
        <TabPane label="按年级班级" name="1"></TabPane>
      
      </Tabs> -->
      <div class="flex">
        <div class="left">
          <!-- <div class="search-line" v-show="tab == 2">
            <Input
              v-model="searchData.studentName"
              class="search-input"
              placeholder="学生姓名"
              clearable
            ></Input>
            <Button
              type="primary"
              style="margin-right: 8px"
              @click="handleGetSearchValue"
              >搜索</Button
            >
            <Button class="reset-btn" @click="handleResetSearch">重置</Button>
          </div> -->
          <div class="table">
            <Table
              ref="selection"
              border
              :columns="leftColumn"
              :data="tableList"
              :loading="tableLoading"
              max-height="550"
              @on-select="onSelect"
              @on-select-cancel="onSelectCancel"
              @on-select-all="onSelectAll"
              @on-select-all-cancel="onSelectAllCancel"
              @on-selection-change="onSelectionChange"
            >
            </Table>
            <div class="page-main" v-if="tab == 2">
              <Page
                :total="coursePageInfo.total"
                show-total
                :current="coursePageInfo.pageNum"
                class="page-right"
                @on-change="handlePageChange"
              ></Page>
            </div>
          </div>
        </div>
        <div class="right">
          <div class="head">选中({{ selectDataList.length }})</div>
          <div class="right-table">
            <Table
              :columns="rightColumns"
              border
              :data="selectDataList"
              height="550"
              ><template slot="action" slot-scope="{ row, index }">
                <Button
                  type="error"
                  size="small"
                  @click="handleRemove(row, index)"
                  >删除</Button
                >
              </template></Table
            >
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <Button style="margin-right: 16px" @click="handleCancleBtn"
          >取消</Button
        >
        <Button type="primary" @click="handleSureBtn">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import ChooseAndModal from '@c/ChooseAndModal.vue';
import orderCenterApi from '@/request/orderCenter/index.js';
import commonApi from '@/request/common';
export default {
  components: {
    ChooseAndModal,

  },
  props: {
    schoolId: {
      type: String,
      default: ''
    },


  },
  data() {
    return {
      show: false,
      tab: '1',// 1 : 按年级班级 2: 按学生个人
      searchData: {
        studentName: '',
      },
      selectDataList: [], // 选中的
      rightStuColumns: [
        {
          title: '学生姓名',
          key: 'studentName',
          align: 'center',
        },
        {
          title: '年级班级',
          key: 'gradeClassName',
          align: 'center',
        },
        {
          title: '操作',
          slot: 'action',
          width: 80,
          align: 'center'
        }
      ],
      rightGradeColumns: [
        {
          title: '年级',
          key: 'gradeName',
          align: 'center',
        },
        {
          title: '操作',
          slot: 'action',
          width: 80,
          align: 'center'
        }
      ],
      gradeColumn: [{
        type: 'selection',
        width: 60,
        align: 'center',
      },
      {
        title: '年级',
        key: 'gradeName',
        align: 'center',
        width: 150
      }, {
        title: '校区',
        key: 'branchName',
        align: 'center',
      },],
      studentColumn: [
        {
          type: 'selection',
          width: 60,
          align: 'center',
        },
        {
          title: '学生姓名',
          key: 'studentName',
          align: 'center',
          width: 130
        },
        {
          title: '年级班级',
          key: 'gradeClassName',
          align: 'center',
          width: 150
        }, {
          title: '校区',
          key: 'branchName',
          align: 'center',
        },
      ], // 课程商品表格column
      tableList: [], // 课程商品列表
      coursePageInfo: {
        total: 0,
        pageSize: 10,
        pageNum: 1
      },
      portOrg: Number(localStorage.getItem('portOrg')),
      tableLoading: false
    };
  },
  watch: {

  },
  computed: {
    leftColumn() {
      return this.gradeColumn
    },
    rightColumns() {
      return this.rightGradeColumns
    }
  },
  created() { },
  mounted() { },
  methods: {
    init() {
      this.coursePageInfo = {
        total: 0,
        pageSize: 10,
        pageNum: 1
      };
      this.tableList = [];
      this.getTableList();
    },
    open(res) {
      this.show = true;

      this.selectDataList = res.list;

      this.init();
    },
    handleCancleBtn() {
      this.show = false;
    },
    // 提交
    handleSureBtn() {
      // if (this.selectCourseList.length < 2) {
      //   this.$Message.error('至少选择2门课程商品');
      //   return null;
      // }
      // isLimitEnroll : 1 年级，2 学生
      this.show = false;
      this.$emit('on-finish', this.getEmitData());
    },
    getIsLimitEnroll() {
      if (this.tab == 1 && this.selectDataList.length > 0) {
        return 1
      } else if (this.tab == 2 && this.selectDataList.length) {
        return 2
      }
      return 0
    },
    getEmitData() {
      let data = []
      if (this.tab == 1) {
        data = this.selectDataList.map(item => {
          return {
            branchId: item.branchId,
            branchName: item.branchName,
            classId: 0,
            className: '',

            gradeId: item.gradeId,
            gradeName: item.gradeName,
            limitCount: 0
          }
        })
      } else {
        data = [...this.selectDataList]
      }
      return {

        isLimitEnroll: this.getIsLimitEnroll(),
        data: data
      }
    },
    getSelectCourseRow(row) {
      console.log(row);
    },
    handlePageChange(page) {
      this.coursePageInfo.pageNum = page;
      this.getTableList();
    },
    handleOnApplyChange(val) {
      this.searchData.providerId = val.orgId;
    },
    getCourseDesc(list) {
      let str = list.map(item => { return item.classroomName }).join('、')
      return str.length > 20 ? str.substring(0, 20) + '...' : str
    },
    onTabClick() {
      this.$Modal.confirm({
        title: '提示',
        content: '<p>切换选择分类将清空已选结果，是否确定？</p>',
        onOk: () => {
          this.coursePageInfo.pageNum = 1
          this.selectDataList = []
          this.getTableList()
        },
        onCancel: () => {
          this.tab = this.tab == 1 ? '2' : '1'
        }
      });

    },
    getTableList() {

      if (this.tab == 1) {
        this.getGradesFunc()
      } else {

        this.getStudentQuerylist()
      }
    },
    // 获取年级
    async getGradesFunc() {
      if (!this.schoolId) {
        this.treeData = [];
        return;
      }
      const params = {
        orgId: this.schoolId
      };
      this.tableLoading = true
      const res = await this.$http.getGradesNew(params);
      this.tableLoading = false
      if (res.status === 200) {
        if (res.message.branches.length) {
          this.tableList = res.message.branches[0]['grades'].map(item => {
            item.id = item.gradeId
            item.branchName = res.message.branches[0]['branchName']
            item.branchId = res.message.branches[0]['branchId']
            return item
          })
          this.handletableList();
          // this.tableList = res.message.branches[0]['grades']
        }

      }
    },
    // 搜索学生列表
    async getStudentQuerylist(params) {
      if (!this.schoolId) {
        return false;
      }
      const obj = {
        schoolId: this.schoolId || '',
        studentName: this.searchData.studentName || '',
        pageNum: this.coursePageInfo.pageNum,
        pageSize: this.coursePageInfo.pageSize
      };
      this.tableLoading = true
      const resp = await commonApi.getStudentQuerylist(obj);
      this.tableLoading = false
      if (resp.status === 200) {
        this.tableList = resp.message.list.map(item => {
          item.id = item.studentId
          item.gradeClassName = item.gradeName + item.className
          return item
        });
        this.coursePageInfo.total = Number(resp.message.total);
        this.handletableList();
      }
    },
    handleGetSearchValue() {
      this.coursePageInfo.pageNum = 1;
      this.coursePageInfo.total = 0;
      this.getTableList();
    },
    handleResetSearch() {
      for (let k in this.searchData) {
        this.searchData[k] = ''
      }
      this.handleGetSearchValue()
    },
    onSelectionChange(selection, row) { },
    onSelectCancel(selection, row) {
      const key = this.selectDataList.findIndex(item => {
        return item.id == row.id;
      });
      if (key != -1) {
        this.selectDataList.splice(key, 1);
      }
    },
    onSelectAll(selection) {
      selection.forEach(item => {
        this.onSelect(selection, item);
      });
    },
    onSelectAllCancel(selection) {
      this.tableList.forEach(item => {
        this.onSelectCancel(selection, item);
      });
    },
    onSelect(selection, row) {
      const key = this.selectDataList.findIndex(item => {
        return item.id == row.id;
      });
      if (key == -1) {
        this.selectDataList.push(row);
      }
    },
    // 删除
    handleRemove(row, index) {
      this.selectDataList.splice(index, 1);
      this.handletableList();
    },
    // 处理列表选中效果
    handletableList() {
      this.tableList.forEach(item => {
        item._checked = false;
        const key = this.selectDataList.findIndex(item_1 => {
          return item_1.id == item.id;
        });
        if (key != -1) {
          item._checked = true;
        }
      });
      this.tableList = Object.assign([], this.tableList);
    },


  }
};
</script>

<style lang="scss" scoped>
.search-line {
  margin-bottom: 16px;
  display: flex;
  .search-input {
    width: 160px;
    margin-right: 16px;
  }
  .search-select {
    width: 250px;
    margin-right: 16px;
  }
}
.iconTips {
  display: flex;
  align-items: center;
  padding-left: 20px;
  margin: 0 0 10px 10px;
  width: 600px;
  height: 30px;
  background-color: #fffae2;
  border: solid 1px #ffe184;
}
.page-main {
  text-align: right;
  padding: 16px 0;
}
.flex {
  display: flex;
  .left {
    width: 70%;
    margin-right: 20px;
  }
  .right {
    width: 28%;
    .head {
      background: rgba(0, 0, 0, 0.05);
      padding: 8px;
      border-radius: 4px;
      font-size: 14px;
      font-weight: 600;
      color: #333;
      margin-bottom: 8px;
    }
  }
}
.modal-footer {
  text-align: right;
  padding: 10px 0;
}
</style>
